import { AccessPermissions } from '@circlefin/permissions'
import { Role } from '@circlefin/permissions/roles'
import { SynthRole } from '@services/synthetic-roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Billing profile section permission.
 * Which users are allowed to view billing profile tab on Billing page?
 */
export const BILLING_PROFILE_SECTION: PermissionSet = {
  access: AccessPermissions.protected,
  includeAll: [
    Role.BILLING_DASHBOARD_ROLE,
    SynthRole.SYNTH_BILLING_PROFILE_ENABLED,
  ],
}
